export const dateTimeSort = (rowA, rowB, columnId) => {
    const parseDate = (dateStr) => {
        const [datePart, timePart] = dateStr.split(', ');
        const [day, month, year] = datePart.split('/');
        return new Date(`${year}-${month}-${day}T${timePart || '00:00:00'}`);
    };

    const dateA = rowA.values[columnId].match(/^\d{4}-\d{2}-\d{2}$/) ? new Date(rowA.values[columnId]) : parseDate(rowA.values[columnId]);
    const dateB = rowB.values[columnId].match(/^\d{4}-\d{2}-\d{2}$/) ? new Date(rowB.values[columnId]) : parseDate(rowB.values[columnId]);

    if (isNaN(dateA) || isNaN(dateB)) {
        return 0;
    }

    return dateA - dateB;
};